import React, { FC } from 'react';

interface AddSeniorCardProps {
  onClick?: () => void;
  /** Compact horizontal layout for mobile */
  compact?: boolean;
}

export const AddSeniorCard: FC<AddSeniorCardProps> = ({ onClick, compact = false }) => {
  if (compact) {
    return (
      <button
        onClick={onClick}
        className="flex items-center gap-3 rounded-xl border-2 border-dashed border-brand-border bg-white/50 p-3 hover:border-brand-accent hover:bg-brand-accent/5 transition-all active:scale-[0.98] group w-full"
      >
        <div className="w-12 h-12 rounded-full bg-brand-bg-warm border border-brand-border flex items-center justify-center shrink-0 group-hover:border-brand-accent group-hover:bg-brand-accent/10 transition-all">
          <span className="material-symbols-outlined text-brand-accent text-xl">add</span>
        </div>
        <div className="flex-1 text-left">
          <span className="block text-base font-semibold text-brand-text group-hover:text-brand-accent transition-colors">Add New Senior</span>
          <span className="block text-sm text-brand-text-muted">Configure a new device</span>
        </div>
        <span className="material-symbols-outlined text-brand-text-muted text-lg group-hover:text-brand-accent transition-colors">
          chevron_right
        </span>
      </button>
    );
  }

  return (
    <button
      onClick={onClick}
      className="flex flex-col items-center justify-center gap-4 rounded-xl border-2 border-dashed border-brand-border bg-white/50 p-4 sm:p-6 hover:border-brand-accent hover:bg-brand-accent/5 transition-all active:scale-[0.98] group h-full min-h-[200px] sm:min-h-[240px]"
    >
      <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-brand-bg-warm border border-brand-border flex items-center justify-center group-hover:scale-110 group-hover:border-brand-accent group-hover:bg-brand-accent/10 transition-all">
        <span className="material-symbols-outlined text-brand-accent text-xl sm:text-2xl">add</span>
      </div>
      <div className="text-center">
        <h4 className="text-lg sm:text-xl font-semibold text-brand-text group-hover:text-brand-accent transition-colors">Add New Senior</h4>
        <p className="text-sm sm:text-base text-brand-text-muted mt-1">Configure a new device</p>
      </div>
    </button>
  );
};

export default AddSeniorCard;
